import { createRouter, createWebHistory } from 'vue-router'
import authService from '../auth/oidc'

// Telas atualmente disponíveis no projeto.
import Login from '../views/LoginView.vue'
import AuthCallback from '../views/AuthCallbackView.vue'
import ResetSenha from '../views/ResetSenhaView.vue'
import Home from '../views/HomeView.vue'
import Clientes from '../views/Clientes/ClientesView.vue'
import CadastroUsuarios from '../views/Usuarios/CadastroUsuariosView.vue'
import ControlePermissoesPerfil from '../views/Usuarios/ControlePermissoesPerfilView.vue'
import CadastroTipoPessoas from '../views/Usuarios/CadastroTipoPessoasView.vue'
import CadastroTipoUsuario from '../views/Adm/CadastroTipoUsuarioView.vue'
import GrupoTelas from '../views/Adm/GrupoTelasView.vue'
import ControleSmtp from '../views/Adm/ControleSmtpView.vue'
import CadastroTipoOperadora from '../views/Adm/CadastroTipoOperadoraView.vue'
import CadastroTipoDocumento from '../views/Adm/CadastroTipoDocumentoView.vue'
import CadastroTipoCliente from '../views/Adm/CadastroTipoClienteView.vue'
import CadastroTelas from '../views/Adm/CadastroTelasView.vue'
import CadastroProdutosConsulta from '../views/Adm/CadastroProdutosConsultaView.vue'
import CadastroPlanosGarantePay from '../views/Adm/CadastroPlanosGarantePayView.vue'
import CadastroModelosContratos from '../views/Adm/CadastroModelosContratosView.vue'
import CadastroListaServicosExtras from '../views/Adm/CadastroListaServicosExtrasView.vue'
import CadastroListaDocumento from '../views/Adm/CadastroListaDocumentoView.vue'
import CadastroFormasPagamento from '../views/Adm/CadastroFormasPagamentoView.vue'
import CadastroDuvidasFrequentes from '../views/Adm/CadastroDuvidasFrequentesView.vue'
import CadastroDocumentosSinistros from '../views/Adm/CadastroDocumentosSinistrosView.vue'
import CadastroAvisoSistema from '../views/Adm/CadastroAvisoSistemaView.vue'
import CadastroMensagensPadrao from '../views/Cadastros/CadastroMensagensPadraoView.vue'
import SegmentosProd from '../views/Produtos/SegmentosProdView.vue'
import Produtos from '../views/Produtos/ProProdutosView.vue'
import Garantepay from '../views/GarantePay/GarantepayView.vue'
import ControleCobrancasGarantePay from '../views/GarantePay/ControleCobrancasGarantePayView.vue'
import TotalMensalPrevistoGarantePay from '../views/GarantePay/TotalMensalPrevistoGarantePayView.vue'
import TotalAnualPrevistoGarantePay from '../views/GarantePay/TotalAnualPrevistoGarantePayView.vue'
import ControleCobrancas from '../views/Cobrancas/ControleCobrancasView.vue'
import TotalAnualCobranca from '../views/Cobrancas/TotalAnualCobrancaView.vue'
import TotalMensalCobranca from '../views/Cobrancas/TotalMensalCobrancaView.vue'
import ControleCobrancasImobiliarias from '../views/CobrancasImobiliaria/ControleCobrancasImobiliariasView.vue'
import PlanosCobertura from '../views/Garantidoras/PlanosCoberturaView.vue'
import Garantidoras from '../views/Garantidoras/GarantidorasView.vue'
import RecargaConsultas from '../views/Garantidoras/RecargaConsultasView.vue'
import Imobiliarias from '../views/Imobiliarias/ImobiliariasView.vue'
import Parceiros from '../views/Parceiros/ParceirosView.vue'
import ContratacaoDetalhe from '../views/Pedidos/ContratacaoDetalheView.vue'
import ContratacaoNegadaDetalhe from '../views/Pedidos/ContratacaoNegadaDetalheView.vue'
import ContratacaoVigenciaFinalizadaDetalhe from '../views/Pedidos/ContratacaoVigenciaFinalizadaDetalheView.vue'
import ContratacaoVigenteDetalhe from '../views/Pedidos/ContratacaoVigenteDetalheView.vue'
import ContratacoesNegadoCancelado from '../views/Pedidos/ContratacoesNegadoCanceladoView.vue'
import ListaContratacoes from '../views/Pedidos/ListaContratacoesView.vue'
import ListaContratacoesVigenciaFinalizada from '../views/Pedidos/ListaContratacoesVigenciaFinalizadaView.vue'
import ListaContratacoesVigentes from '../views/Pedidos/ListaContratacoesVigentesView.vue'
import NovaContratacao from '../views/Pedidos/NovaContratacaoView.vue'
import NovaContratacaoGarantia from '../views/Pedidos/NovaContratacaoView.vue'
import TombamentoPlanilha from '../views/Pedidos/TombamentoPlanilhaView.vue'
import RelatorioConcentracaoContratosAtivos from '../views/Relatorios/RelatorioConcentracaoContratosAtivosView.vue'
import RelatorioContratosAtivos from '../views/Relatorios/RelatorioContratosAtivosView.vue'
import RelatorioContratosAVencer from '../views/Relatorios/RelatorioContratosAVencerView.vue'
import RelatorioContratosEncerrados from '../views/Relatorios/RelatorioContratosEncerradosView.vue'
import RelatorioEvolucaoCarteira from '../views/Relatorios/RelatorioEvolucaoCarteiraView.vue'
import RelatorioProvisaoSinistros from '../views/Relatorios/RelatorioProvisaoSinistrosView.vue'
import RelatorioUsoConsultasAssinaturas from '../views/Relatorios/RelatorioUsoConsultasAssinaturasView.vue'
import CadastroSinistros from '../views/Sinistros/CadastroSinistrosView.vue'
import ListaSinistrosAcordoParcelas from '../views/Sinistros/ListaSinistrosAcordoParcelasView.vue'
import ListaSinistrosAcordo from '../views/Sinistros/ListaSinistrosAcordoView.vue'
import ListaSinistrosAprovacao from '../views/Sinistros/ListaSinistrosAprovacaoView.vue'
import ListaSinistrosCobranca from '../views/Sinistros/ListaSinistrosCobrancaView.vue'
import ListaSinistrosPagamento from '../views/Sinistros/ListaSinistrosPagamentoView.vue'
import ListaSinistros from '../views/Sinistros/ListaSinistrosView.vue'
import SinistroAcordoDetalhe from '../views/Sinistros/SinistroAcordoDetalheView.vue'
import SinistroAprovacaoDetalhe from '../views/Sinistros/SinistroAprovacaoDetalheView.vue'
import SinistroCobrancaDetalhe from '../views/Sinistros/SinistroCobrancaDetalheView.vue'
import SinistroPagamentoDetalhe from '../views/Sinistros/SinistroPagamentoDetalheView.vue'
import CadastroChamados from '../views/Suporte/CadastroChamadosView.vue'
import ChamadosAndamento from '../views/Suporte/ChamadosAndamentoView.vue'
import SupTiposChamados from '../views/Suporte/SupTiposChamadosView.vue'

/*
 * TELAS AGUARDANDO LIBERAÇÃO
 *
 * Os imports e as rotas abaixo permanecem documentados, mas inativos enquanto
 * os respectivos arquivos .vue não estiverem nesta cópia do frontend.
 * Ao trazer um módulo, basta restaurar seu import e sua entrada em `routes`.
 *
 * Produtos e operação:
 * Garantidoras, RecargaConsultas, ControleCobrancas,
 * TotalMensalCobranca, TotalAnualCobranca, ControleCobrancasImobiliarias,
 * Parceiros e Imobiliarias.
 *
 * Suporte e relatórios:
 * SupTiposChamados, CadastroChamados, ChamadosAndamento,
 * RelatorioContratosAtivos, RelatorioContratosAVencer,
 * RelatorioContratosEncerrados, RelatorioProvisaoSinistros,
 * RelatorioConcentracaoContratosAtivos, RelatorioEvolucaoCarteira e
 * RelatorioUsoConsultasAssinaturas.
 *
 * Contratações e sinistros:
 * ListaContratacoes, ListaContratacoesVigentes, ContratacaoDetalhe,
 * NovaContratacao, NovaContratacaoGarantia, ContratacoesNegadoCancelado,
 * ContratacaoNegadaDetalhe, ContratacaoVigenteDetalhe,
 * ListaContratacoesVigenciaFinalizada, ContratacaoVigenciaFinalizadaDetalhe,
 * TombamentoPlanilha, ListaSinistros, ListaSinistrosAprovacao,
 * ListaSinistrosPagamento, ListaSinistrosCobranca, ListaSinistrosAcordo,
 * CadastroSinistros, SinistroAprovacaoDetalhe, SinistroPagamentoDetalhe,
 * SinistroCobrancaDetalhe, SinistroAcordoDetalhe e ListaSinistrosAcordoParcelas.
 */

const routes = [
  { path: '/callback', name: 'AuthCallbackShort', component: AuthCallback, meta: { hideHeader: true } },
  { path: '/auth/callback', name: 'AuthCallback', component: AuthCallback, meta: { hideHeader: true } },
  { path: '/:urlGarantidora?', name: 'login', component: Login, meta: { hideHeader: true } },
  { path: '/Home', name: 'Home', component: Home },
  { path: '/ResetSenha/:id/:key', name: 'ResetSenha', component: ResetSenha, meta: { hideHeader: true } },
  { path: '/Clientes', name: 'Clientes', component: Clientes },
  { path: '/CadastroUsuarios/:id?', name: 'CadastroUsuarios', component: CadastroUsuarios },
  { path: '/ControlePermissoesPerfil', name: 'ControlePermissoesPerfil', component: ControlePermissoesPerfil },
  { path: '/CadastroTipoPessoas', name: 'CadastroTipoPessoas', component: CadastroTipoPessoas },
  { path: '/CadastroTipoUsuario', name: 'CadastroTipoUsuario', component: CadastroTipoUsuario },
  { path: '/GrupoTelas', name: 'GrupoTelas', component: GrupoTelas },
  { path: '/ControleSmtp', name: 'ControleSmtp', component: ControleSmtp },
  { path: '/CadastroTipoOperadora', name: 'CadastroTipoOperadora', component: CadastroTipoOperadora },
  { path: '/CadastroTipoDocumento', name: 'CadastroTipoDocumento', component: CadastroTipoDocumento },
  { path: '/CadastroTipoCliente', name: 'CadastroTipoCliente', component: CadastroTipoCliente },
  { path: '/CadastroTelas', name: 'CadastroTelas', component: CadastroTelas },
  { path: '/CadastroProdutosConsulta', name: 'CadastroProdutosConsulta', component: CadastroProdutosConsulta },
  { path: '/CadastroPlanosGarantePay', name: 'CadastroPlanosGarantePay', component: CadastroPlanosGarantePay },
  { path: '/CadastroModelosContratos', name: 'CadastroModelosContratos', component: CadastroModelosContratos },
  { path: '/CadastroListaServicosExtras', name: 'CadastroListaServicosExtras', component: CadastroListaServicosExtras },
  { path: '/CadastroListaDocumento', name: 'CadastroListaDocumento', component: CadastroListaDocumento },
  { path: '/CadastroFormasPagamento', name: 'CadastroFormasPagamento', component: CadastroFormasPagamento },
  { path: '/CadastroDuvidasFrequentes', name: 'CadastroDuvidasFrequentes', component: CadastroDuvidasFrequentes },
  { path: '/CadastroDocumentosSinistros', name: 'CadastroDocumentosSinistros', component: CadastroDocumentosSinistros },
  { path: '/CadastroAvisoSistema', name: 'CadastroAvisoSistema', component: CadastroAvisoSistema },
  { path: '/CadastroMensagensPadrao', name: 'CadastroMensagensPadrao', component: CadastroMensagensPadrao },
  { path: '/SegmentosProd', name: 'SegmentosProd', component: SegmentosProd },
  { path: '/Produtos', name: 'Produtos', component: Produtos },
  { path: '/Garantepay', name: 'Garantepay', component: Garantepay },
  { path: '/ControleCobrancasGarantePay', name: 'ControleCobrancasGarantePay', component: ControleCobrancasGarantePay },
  { path: '/TotalMensalPrevistoGarantePay', name: 'TotalMensalPrevistoGarantePay', component: TotalMensalPrevistoGarantePay },
  { path: '/TotalAnualPrevistoGarantePay', name: 'TotalAnualPrevistoGarantePay', component: TotalAnualPrevistoGarantePay },
  { path: '/ControleCobrancas', name: 'ControleCobrancas', component: ControleCobrancas },
  { path: '/TotalAnualCobranca', name: 'TotalAnualCobranca', component: TotalAnualCobranca },
  { path: '/TotalMensalCobranca', name: 'TotalMensalCobranca', component: TotalMensalCobranca },
  { path: '/CobrancasImobiliarias', alias: '/ControleCobrancasImobiliarias', name: 'ControleCobrancasImobiliarias', component: ControleCobrancasImobiliarias },
  { path: '/PlanosCobertura', name: 'PlanosCobertura', component: PlanosCobertura },
  { path: '/Garantidoras', name: 'Garantidoras', component: Garantidoras },
  { path: '/RecargaConsultas', name: 'RecargaConsultas', component: RecargaConsultas },
  { path: '/Imobiliarias', name: 'Imobiliarias', component: Imobiliarias },
  { path: '/Parceiros', name: 'Parceiros', component: Parceiros },
  { path: '/ContratacaoDetalhe/:idPed?', name: 'ContratacaoDetalhe', component: ContratacaoDetalhe },
  { path: '/ContratacaoNegadaDetalhe/:idPed?', name: 'ContratacaoNegadaDetalhe', component: ContratacaoNegadaDetalhe },
  { path: '/ContratacaoVigenciaFinalizadaDetalhe/:idPed?', name: 'ContratacaoVigenciaFinalizadaDetalhe', component: ContratacaoVigenciaFinalizadaDetalhe },
  { path: '/ContratacaoVigenteDetalhe/:idPed?', name: 'ContratacaoVigenteDetalhe', component: ContratacaoVigenteDetalhe },
  { path: '/ContratacoesNegadoCancelado', name: 'ContratacoesNegadoCancelado', component: ContratacoesNegadoCancelado },
  { path: '/ListaContratacoes', name: 'ListaContratacoes', component: ListaContratacoes },
  { path: '/ListaContratacoesVigenciaFinalizada', name: 'ListaContratacoesVigenciaFinalizada', component: ListaContratacoesVigenciaFinalizada },
  { path: '/ListaContratacoesVigentes', name: 'ListaContratacoesVigentes', component: ListaContratacoesVigentes },
  { path: '/NovaContratacao/:idPed?', name: 'NovaContratacao', component: NovaContratacao },
  { path: '/NovaContratacaoGarantia/:idPed?', name: 'NovaContratacaoGarantia', component: NovaContratacaoGarantia },
  { path: '/TombamentoPlanilha', name: 'TombamentoPlanilha', component: TombamentoPlanilha },
  { path: '/RelatorioConcentracaoContratosAtivos', name: 'RelatorioConcentracaoContratosAtivos', component: RelatorioConcentracaoContratosAtivos },
  { path: '/RelatorioContratosAtivos', name: 'RelatorioContratosAtivos', component: RelatorioContratosAtivos },
  { path: '/RelatorioContratosAVencer', name: 'RelatorioContratosAVencer', component: RelatorioContratosAVencer },
  { path: '/RelatorioContratosEncerrados', name: 'RelatorioContratosEncerrados', component: RelatorioContratosEncerrados },
  { path: '/RelatorioEvolucaoCarteira', name: 'RelatorioEvolucaoCarteira', component: RelatorioEvolucaoCarteira },
  { path: '/RelatorioProvisaoSinistros', name: 'RelatorioProvisaoSinistros', component: RelatorioProvisaoSinistros },
  { path: '/RelatorioUsoConsultasAssinaturas', name: 'RelatorioUsoConsultasAssinaturas', component: RelatorioUsoConsultasAssinaturas },
  { path: '/CadastroSinistros/:id?', name: 'CadastroSinistros', component: CadastroSinistros },
  { path: '/ListaSinistrosAcordoParcelas', name: 'ListaSinistrosAcordoParcelas', component: ListaSinistrosAcordoParcelas },
  { path: '/ListaSinistrosAcordo', name: 'ListaSinistrosAcordo', component: ListaSinistrosAcordo },
  { path: '/ListaSinistrosAprovacao', name: 'ListaSinistrosAprovacao', component: ListaSinistrosAprovacao },
  { path: '/ListaSinistrosCobranca', name: 'ListaSinistrosCobranca', component: ListaSinistrosCobranca },
  { path: '/ListaSinistrosPagamento', name: 'ListaSinistrosPagamento', component: ListaSinistrosPagamento },
  { path: '/ListaSinistros', name: 'ListaSinistros', component: ListaSinistros },
  { path: '/SinistroAcordoDetalhe/:id?', name: 'SinistroAcordoDetalhe', component: SinistroAcordoDetalhe },
  { path: '/SinistroAprovacaoDetalhe/:id?', name: 'SinistroAprovacaoDetalhe', component: SinistroAprovacaoDetalhe },
  { path: '/SinistroCobrancaDetalhe/:id?', name: 'SinistroCobrancaDetalhe', component: SinistroCobrancaDetalhe },
  { path: '/SinistroPagamentoDetalhe/:id?', name: 'SinistroPagamentoDetalhe', component: SinistroPagamentoDetalhe },
  { path: '/CadastroChamados', name: 'CadastroChamados', component: CadastroChamados },
  { path: '/ChamadosAndamento', name: 'ChamadosAndamento', component: ChamadosAndamento },
  { path: '/SupTiposChamados', name: 'SupTiposChamados', component: SupTiposChamados }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach(async (to, from, next) => {
  // 1) Sempre rola a página pro topo
  window.scrollTo({ top: 0, behavior: 'smooth' })

  // 2) Quais rotas NÃO precisam de autenticação
  const publicPages = ['ResetSenha', 'AuthCallback', 'AuthCallbackShort']
  const isPublic = publicPages.includes(to.name)

  if (isPublic || (to.name === 'login' && to.query.authError === '1')) {
    // Se for rota de login ou reset, deixa passar
    return next()
  }

  try {
    const authenticated = await authService.isAuthenticated()

    if (to.name === 'login') {
      const urlGarantidora = authService.normalizeGuarantorUrl(to.params.urlGarantidora)
      const activeGuarantorUrl = authService.getActiveGuarantorUrl()

      if (!urlGarantidora) {
        const logoutGuarantorUrl = authService.consumeGuarantorLogoutUrl()
        if (logoutGuarantorUrl) {
          return next({
            name: 'login',
            params: { urlGarantidora: logoutGuarantorUrl },
            replace: true
          })
        }
      }

      if (authenticated && (!urlGarantidora ||
        (activeGuarantorUrl && activeGuarantorUrl.toLowerCase() === urlGarantidora.toLowerCase()))) {
        return next('/Home')
      }

      await authService.signInRedirect('/Home', { urlGarantidora })
      return
    }

    if (authenticated) {
      return next()
    }

    await authService.signInRedirect(to.fullPath)
  } catch (error) {
    console.error('Falha ao iniciar autenticacao OIDC.', error)
    return next(false)
  }
})

export default router
